import React from 'react';
import L from 'leaflet';
import { Marker, Popup } from 'react-leaflet';
import logo from '../../assets/images/SBN_icon.png';
import { longitudeOffsets } from '../LeafletMap';
import { ShipData } from '../../services/types';

const shipIcon = new L.Icon({
  iconUrl: logo,
  iconSize: [20, 25],
  popupAnchor: [0, 50]
});

type ShipMarkerProps = {
  ship: ShipData;
  clickHandler: () => void;
  index: number;
}

export const ShipMarker = ({ ship, clickHandler, index }: ShipMarkerProps) => {

  const { ShipName: name, latitude: lat, longitude: long } = ship;
  const shipName = `Seabourn ${name}`;

  const initMarker = (ref: any) => {
    if (ref) {
      ref.leafletElement.closePopup = clickHandler;
      ref.leafletElement.openPopup();
    }
  };

  const markerProps = {
    ref: initMarker,
    zIndexOffset: 210,
    icon: shipIcon,
    onClick: clickHandler,
    riseOnHover: true,
  };

  const popup = <Popup tabIndex={-1} closeOnClick={false} autoClose={false} autoPan={false} closeButton={false}>
    {shipName}
  </Popup>;

  return (
    <div>
      {longitudeOffsets.map((longOffset, i) => (
        <Marker
          key={"Ship" + i + index}
          position={[
            lat, long + longOffset
          ]}
          {...markerProps}
        >
          {popup}
        </Marker>
      ))}
    </div>
  );
};